import { Link } from "@tanstack/react-router";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { AppReportDialog } from "#/components/AppReportDialog";

const BROWSE_SEARCH = {
	sort: "newest" as const,
	q: "",
	discClass: [] as string[],
	condition: [] as string[],
	color: [] as string[],
	shipsTo: [] as string[],
	country: [] as string[],
	plasticType: [] as string[],
	priceMin: "" as number | "",
	priceMax: "" as number | "",
	weightMin: "" as number | "",
	weightMax: "" as number | "",
	discModelIds: [] as string[],
	manufacturerIds: [] as string[],
	speedMin: "" as number | "",
	speedMax: "" as number | "",
	glideMin: "" as number | "",
	glideMax: "" as number | "",
	turnMin: "" as number | "",
	turnMax: "" as number | "",
	fadeMin: "" as number | "",
	fadeMax: "" as number | "",
	distanceKm: "" as number | "",
};

export function Footer() {
	const { t } = useTranslation();
	const [reportOpen, setReportOpen] = useState(false);

	return (
		<footer
			className="border-t border-border bg-muted"
			style={{ viewTransitionName: "site-footer" }}
		>
			<div className="page-wrap py-8 flex flex-wrap items-center justify-between gap-4">
				<div className="flex items-center gap-3">
					<span className="display-title text-[22px] tracking-[0.04em] text-muted-foreground">
						<b className="text-primary-accessible">RE:</b>DISC
					</span>
					<span className="text-xs text-muted-foreground">
						{t("footer.tagline")}
					</span>
				</div>
				<div className="flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-xs font-semibold text-muted-foreground">
					<Link
						to="/listings"
						search={BROWSE_SEARCH}
						className="transition-colors hover:text-foreground"
					>
						{t("footer.browse")}
					</Link>
					<Link to="/sell" className="transition-colors hover:text-foreground">
						{t("footer.sell")}
					</Link>
					<button
						type="button"
						onClick={() => setReportOpen(true)}
						className="transition-colors hover:text-foreground"
					>
						{t("footer.reportIssue")}
					</button>
					<Link
						to="/privacy"
						className="transition-colors hover:text-foreground"
					>
						{t("footer.privacy")}
					</Link>
					<Link
						to="/accessibility"
						className="transition-colors hover:text-foreground"
					>
						{t("footer.accessibility")}
					</Link>
					<Link to="/terms" className="transition-colors hover:text-foreground">
						{t("footer.terms")}
					</Link>
					<span className="text-muted-foreground">
						© {new Date().getFullYear()}
					</span>
				</div>
			</div>
			<AppReportDialog open={reportOpen} onOpenChange={setReportOpen} />
		</footer>
	);
}
